module.exports = __webpack_public_path__ + "static/img/normal_u73.c2b25196.svg";